import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {connect} from 'react-redux';
import * as basketActions from '../actions/basketActions';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import {Map} from 'immutable';
import * as _ from 'lodash';
import DealCustomizeView from '../components/Deals/DealCustomizeView';
import Spinner from '../components/Spinner/Spinner';


class DealsCustomizeScreen extends Component {
  constructor(props) {
    super(props);

    this.onClose = this.onClose.bind(this);
    this.addToBasket = this.addToBasket.bind(this);
    const locationState = props.location.state;

    this.state = {
      deal: Map(),
      userData: !_.isEmpty(locationState) ? _.clone(locationState.options) : [],
      action: !_.isEmpty(locationState) ? locationState.action : 'add',
      index: !_.isEmpty(locationState) ? locationState.index : null,
      quantity: !_.isEmpty(locationState) ? locationState.quantity : 1,
      currentRestaurantId: props.currentRestaurantId,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let result = {};

    if (nextProps.restaurant.deals) {
      const deal = nextProps.restaurant.deals.find(
          d => d.id === parseInt(nextProps.match.params.productId, 10));
      if (_.isEmpty(deal) || prevState.deal.get('id') === deal.id) {
        return result;
      }

      result = {
        deal: prevState.deal.merge(deal),
      };
    }

    return result;
  }

  static renderLoading(t) {
    return (
      <Spinner text={t('loading_deals')} />
    );
  }

  onClose() {
    const {language, restaurant} = this.props;
    if (this.props.history.length > 3) {
      this.props.history.goBack();
    } else {
      this.props.history.push(`/${language}/${restaurant.name_for_url}/products/deals`)
    }
  }

  addToBasket(data) {
    const {deal, action, index, quantity} = this.state;
    const result = {
      productId: deal.get('id'),
      options: data,
      quantity: quantity,
      type: 'deals'
    };
    if (action === 'add') {
      this.props.addToBasket(result);
    } else if (action === 'update') {
      const data = {
        type: 'deals',
        index: index,
        ...result,
      };
      this.props.updateBasket(data);
    }
    this.props.openBasket();
    this.onClose();
  }

  sortDealCompositions(data) {
    data.compositions = _.orderBy(data.compositions, ['type', 'position'], ['asc']);
    return data;
  }

  render() {
    const {language, restaurant, t} = this.props;
    const {deal, userData} = this.state;

    if (deal.isEmpty()) {
      return DealsCustomizeScreen.renderLoading(t);
    }
    return (
      <DealCustomizeView
        userData={userData}
        deal={this.sortDealCompositions(deal.toJS())}
        language={language}
        onClose={this.onClose}
        restaurant={restaurant}
        addToBasket={this.addToBasket}
      />
    );
  }
}

DealsCustomizeScreen.propTypes = {
  language: PropTypes.string,
  restaurant: PropTypes.object,
  updateBasket: PropTypes.func,
  addToBasket: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    language: state.language.defaultLanguage,
    restaurant: state.restaurants.item || {},
    currentRestaurantId: state.restaurants.selectedId,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateBasket: bindActionCreators(basketActions.updateBasket, dispatch),
    openBasket: bindActionCreators(basketActions.openBasket, dispatch),
    addToBasket: bindActionCreators(basketActions.addToBasket, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(
    translate('translations')(DealsCustomizeScreen));


// WEBPACK FOOTER //
// ./src/containers/Deals.js